/** Фото користувача: адреса для показу і перевірка файлу перед обрізанням */

/** Типи, які приймає бекенд для фото профілю */
export const PHOTO_ACCEPT = ['image/jpeg', 'image/png', 'image/webp']

/**
 * Межа для вихідного файлу. На сервер іде обрізаний квадрат PHOTO_OUTPUT_SIZE у JPEG
 * (десятки–сотні КБ), тож серверне обмеження 3 МБ стосується вже його.
 */
export const PHOTO_MAX_SOURCE_MB = 15

/** Сторона квадрата, який зберігається на сервері */
export const PHOTO_OUTPUT_SIZE = 512

/** URL фото користувача з об'єкта photo; заглушки з /assets не вважаємо фото */
export const resolveUserPhotoUrl = (photo: unknown): string | null => {
    const url = typeof photo === 'object' && photo !== null ? (photo as { url?: unknown }).url : null
    if (typeof url !== 'string' || url === '' || url.startsWith('/assets/')) return null
    return url
}

/** Пояснення, чому файл не підходить; null — можна обрізати й зберегти */
export const validatePhotoFile = (file: { type: string; size: number; name?: string }): string | null => {
    if (!PHOTO_ACCEPT.includes(file.type)) {
        return 'Підходять лише зображення JPG, PNG або WEBP.'
    }
    if (file.size > PHOTO_MAX_SOURCE_MB * 1024 * 1024) {
        const sizeMb = (file.size / 1024 / 1024).toFixed(1).replace('.', ',')
        return `Файл завеликий (${sizeMb} МБ). Максимум — ${PHOTO_MAX_SOURCE_MB} МБ.`
    }
    return null
}
